import { render, staticRenderFns } from "./ChangeReturn.vue?vue&type=template&id=45ce82dd"
import script from "./ChangeReturn.vue?vue&type=script&lang=js"
export * from "./ChangeReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports